<style>
@import '../../../custom/css/recebidas.css';
</style>

<template>
    <div class="recebidas" id="inicio">
        <div class="row m-0" v-if="cotacoes !== []">
        <div class="col-12 my-4">
        <h1
            class="
                title
                font-weight-bold
                text-uppercase
                d-flex
                justify-content-center
                "
        >
            {{
            cotacoes.length > 0
                ? 'Orçamentos Recebidos'
                : 'Sem Orçamentos Recebidos'
            }}
        </h1>
        </div>
        <div
            class="col-lg-4 col-md-6 col-sm-12 col-12"
            v-for="(cotacao, index) in cotacoes"
            :key="index"
        >
            <div class="card-cotacao">
                <div class="cc-header d-flex">
                    <div class="cc-sub-title m-r-25">
                        <img
                        class="imagem-archive-cotacao"
                        src="@/assets/img/icons/file-archive.png"
                        alt="Ícone para representar a cotação"
                    />
                    </div>
                <div class="cc-sub-title">
                <div> Data:
                    <div class="cc-sub-result">{{ cotacao.criado_em }}</div>
                </div>
                <div>
                    Cód:
                    <div class="cc-sub-result">{{ cotacao.id }}</div>
                </div>
            </div>
        </div>

        <div class="cc-footer">
            <div class="btn-ver-cotacao" @click="verCotacao(cotacao.id)">
                    Ver Cotação
            </div>
    </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import scrollToElement from '@/mixins/scrollToElement';

export default {
    mixins: [scrollToElement],
    name: 'recebida',
    data() {
        return {
            idLojista: null,
        }
    },
    computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
        token: (state) => state.token,
        dadosUsuario: (state) => state.dadosUsuario,
        cotacoes: (state) => state.cotacoes,
        cotacoesContagem: (state) => state.cotacoesContagem,
    }),
    
    },
    mounted() {
    this.scrollToElement();
    },
    created() {
    this.scrollToElement();
    this.requestBackEnd();
    
    },
    methods: {
    requestBackEnd() {
        this.$store.dispatch('startLoader');
        const user = {
            'id': this.$route.params.id,
            'type' : 3
        }
    this.$store
            .dispatch('showCotacoesAdm', user)
            .then((response) => {
            })
            .catch(() => {
                // this.makeToast('Oopss', 'E-mail não cadastrador ou E-mail inválido!', 'danger')
            })
            this.$store.dispatch('endLoader');
    },

    verCotacao(idCotacao) {
        if (!this.checkIsEmpty(idCotacao)) {
        this.$router.push({
            name: 'administrador-cotacao-recebida',
            params: { id: idCotacao, idLojista: this.$route.params.id },
        });
        }
    },
checkIsEmpty(value) {
        if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
        ) {
        return true;
        }
        return false;
    },
},
};
</script>
